module.exports = __webpack_public_path__ + "img/SPHY_ACT.003e8add.png";